export class PhoneCodeOptionInterface {
    label: string;
    value: string;
    classes: string;
}
